import { type UseParseContentForItemSetInput, useParseContentForDisplay } from './content-parser';

export function useParseContentForItemSet(params: UseParseContentForItemSetInput) {
  const { questionGroupId } = params;
  const { parseContentForDisplay: parseContentForItemSet } = useParseContentForDisplay({
    questionGroupId,
  });

  return {
    parseContentForItemSet,
  };
}
